/**
 * Cache time constants for React Query
 */
export const CACHE_TIME_10_MIN = 10 * 60 * 1000
export const CACHE_TIME_30_MIN = 30 * 60 * 1000

export const EMBED_ICON_MAP = {
  mailchimp: { name: 'pv-mailchimp', color: '241C15' },
  hubspot: { name: 'pv-hubspot', color: 'FF7A59' },
  hubspotsales: { name: 'pv-hubspot', color: 'FF7A59' },
  marketo: { name: 'pv-marketo', color: '5C4C9F' },
  campaignmonitor: { name: 'pv-camp-monitor', color: '7856FF' },
  sharpspring: { name: 'pv-sharpspring', color: '84C340' },
  gmail: { name: 'pv-gmail', color: '212121' },
  html: { name: 'email-fill', color: '1ec95b' },
} as const
